export const ASSISTANT_PROMPTS = [
  "What kind of AI systems do you build?",
  "Tell me about your background and experience.",
  "What kinds of products and systems have you built?",
  "How can I work with you on an AI project?",
  "What is your philosophy on production AI?",
  "Can I download your CV from here?",
];
